import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Transformers } from '@supabase/realtime-js';
export var SupabaseRealtimeClient = /*#__PURE__*/function () {
  function SupabaseRealtimeClient(socket, headers, schema, tableName) {
    _classCallCheck(this, SupabaseRealtimeClient);

    var chanParams = {};
    var topic = tableName === '*' ? "realtime:".concat(schema) : "realtime:".concat(schema, ":").concat(tableName);
    var userToken = headers['Authorization'].split(' ')[1];

    if (userToken) {
      chanParams['user_token'] = userToken;
    }

    this.subscription = socket.channel(topic, chanParams);
  }

  _createClass(SupabaseRealtimeClient, [{
    key: "getPayloadRecords",
    value: function getPayloadRecords(payload) {
      var records = {
        new: {},
        old: {}
      };

      if (payload.type === 'INSERT' || payload.type === 'UPDATE') {
        records.new = Transformers.convertChangeData(payload.columns, payload.record);
      }

      if (payload.type === 'UPDATE' || payload.type === 'DELETE') {
        records.old = Transformers.convertChangeData(payload.columns, payload.old_record);
      }

      return records;
    }
    /**
     * The event you want to listen to.
     *
     * @param event The event
     * @param callback A callback function that is called whenever the event occurs.
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      var _this = this;

      this.subscription.on(event, function (payload) {
        var enrichedPayload = {
          schema: payload.schema,
          table: payload.table,
          commit_timestamp: payload.commit_timestamp,
          eventType: payload.type,
          new: {},
          old: {},
          errors: payload.errors
        };
        enrichedPayload = Object.assign(Object.assign({}, enrichedPayload), _this.getPayloadRecords(payload));
        callback(enrichedPayload);
      });
      return this;
    }
    /**
     * Enables the subscription.
     */

  }, {
    key: "subscribe",
    value: function subscribe() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      this.subscription.onError(function (e) {
        return callback('SUBSCRIPTION_ERROR', e);
      });
      this.subscription.onClose(function () {
        return callback('CLOSED');
      });
      this.subscription.subscribe().receive('ok', function () {
        return callback('SUBSCRIBED');
      }).receive('error', function (e) {
        return callback('SUBSCRIPTION_ERROR', e);
      }).receive('timeout', function () {
        return callback('RETRYING_AFTER_TIMEOUT');
      });
      return this.subscription;
    }
  }]);

  return SupabaseRealtimeClient;
}();